export const MOLDOVA_TZ_ID = "Europe/Chisinau";

const TZ_PARTS_FORMATTER_CACHE = new Map();

export function partsInTZ(dateLike, timeZone = MOLDOVA_TZ_ID) {
   const d = new Date(dateLike);
   if (Number.isNaN(d.getTime())) return null;
   const cacheKey = String(timeZone || MOLDOVA_TZ_ID);
   let formatter = TZ_PARTS_FORMATTER_CACHE.get(cacheKey);
   if (!formatter) {
      formatter = new Intl.DateTimeFormat("en-GB", {
         timeZone: cacheKey,
         hour12: false,
         year: "numeric",
         month: "2-digit",
         day: "2-digit",
         hour: "2-digit",
         minute: "2-digit",
         second: "2-digit",
      });
      TZ_PARTS_FORMATTER_CACHE.set(cacheKey, formatter);
   }
   const p = formatter.formatToParts(d);
   let y = 0;
   let m = 0;
   let day = 0;
   let H = 0;
   let M = 0;
   let S = 0;
   for (const part of p) {
      const value = Number(part?.value || 0);
      if (!Number.isFinite(value)) continue;
      if (part.type === "year") y = value;
      else if (part.type === "month") m = value;
      else if (part.type === "day") day = value;
      else if (part.type === "hour") H = value;
      else if (part.type === "minute") M = value;
      else if (part.type === "second") S = value;
   }
   return {
      y,
      m,
      d: day,
      H,
      M,
      S,
   };
}

export function localKeyFromTs(dateLike, timeZone = MOLDOVA_TZ_ID) {
   const p = partsInTZ(dateLike, timeZone);
   if (!p) return "";
   return `${p.y}-${String(p.m).padStart(2, "0")}-${String(p.d).padStart(2, "0")}|${String(
      p.H,
   ).padStart(2, "0")}:${String(p.M).padStart(2, "0")}`;
}

export function tzOffsetMinutesAt(tsMs, timeZone = MOLDOVA_TZ_ID) {
   const p = partsInTZ(tsMs, timeZone);
   if (!p) return 0;
   const asUTC = Date.UTC(p.y, p.m - 1, p.d, p.H, p.M, p.S);
   return (asUTC - tsMs) / 60000;
}

export function busyLocalKeyFromStored(value) {
   const d = new Date(value);
   if (Number.isNaN(d.getTime())) return "";
   const offMin = tzOffsetMinutesAt(d.getTime(), MOLDOVA_TZ_ID);
   const base = new Date(d.getTime() - offMin * 60000);
   return localKeyFromTs(base.getTime(), MOLDOVA_TZ_ID);
}
